import Products from "@/components/Products/Products";
import Toolbar from "@/components/Toolbar/Toolbar";
import BottomToolbar from "@/components/BottomToolbar/BottomToolbar";
import {
  ContentChildrenProps,
  wrapContent,
} from "@/components/ContentWrapper/ContentWrapper";
import NoResults from "@/components/NoResults/NoResults";
import { useNostoAppState } from "@nosto/search-js/preact/hooks";

export function SerpBody({ foundProducts, loading }: ContentChildrenProps) {
  const { query, response } = useNostoAppState((state) => ({
    query: state.query?.query,
    response: state.response,
  }));
  const total = response?.products?.total;
  const showNoResults = !foundProducts && !loading;

  return (
    <>
      <div className="plp__heading">
        {query && <h1>Search results for &ldquo;{query}&rdquo;</h1>}
        {!showNoResults && !loading && <span>{total} products</span>}
      </div>
      <Toolbar productsCount={total} showNoResults={showNoResults} />
      {showNoResults ? <NoResults /> : <Products searchTrackType="serp" />}
      {!showNoResults && <BottomToolbar />}
    </>
  );
}

export default wrapContent("search", SerpBody);
